import LoginComponent from "src/components/LoginComponent";

export default function Login() {  
  return (
    <LoginComponent />
  )
}